import React from 'react';
import Menu from '../../nav/menu';
import Footer from '../../nav/footer';
import useMedia from 'use-media';
import CarroucelImg from '../../components/carroucelImg';
import { pageText, pageText2, pageText3 } from './specialtyCoffeeText';
import { generalStyleDivs } from '../../styles.js';
import { textInResolution } from '../../multiFunctions.js';

function SpecialtyCoffeePage() {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    let screenSize = {
      width: window.screen.width,
      height: window.screen.height
    }
    const carroucelImg1 = [
        {
            url: '/img/specialtyCoffee3.png'
        },
        {
            url: '/img/specialtyCoffee2.png'
        },
        {
            url: '/img/specialtyCoffee1.png'
        }
    ];
    let textDivStyle = {
      fontSize: textInResolution('large', 'large', 'x-large', 'x-large', screenSize)
    }
    return (
        <>
          <Menu/>
          {isLargeScreen &&
          <div style={{ width: "100%", justifyContent: "center", display: "flex", backgroundColor: "#F4DFBB" }}>
            <div style={{display: "flex", flexFlow: "row", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat", padding: "10px", maxWidth: "1200px" }}>
              <div style={{ width: "30%", display: "flex", justifyContent: "space-around", flexFlow: "column", alignItems: "center" }}>
                <div>
                  <img src="/img/specialtyCoffee1.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                </div>
                <div>
                  <img src="/img/specialtyCoffee2.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                </div>
                <div>
                  <img src="/img/specialtyCoffee3.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                </div>
              </div>
              <div style={{ width: "70%", display: "flex" }}>
                <div style={{ height: "100%" }}>
                  <div style={{ ...textDivStyle, ...generalStyleDivs,
                    height: "100%",
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center" }}>
                    <span style={{ padding: "10px" }} dangerouslySetInnerHTML={{ __html: pageText }} />
                    <br/>
                    <span style={{ padding: "10px" }} dangerouslySetInnerHTML={{ __html: pageText2 }} />
                    <br/>
                    <span style={{ padding: "10px" }} dangerouslySetInnerHTML={{ __html: pageText3 }} />
                    <br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          {isSmallScreen &&
            <div style={{ justifyContent: "center", display: "flex", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat", flexFlow: "column", padding: "10px" }}>
                <div style={{ maxHeight: "230px", height: "210px", width: "100%", paddingTop: "15px", display: "flex", justifyContent: "center" }}>
                    <CarroucelImg carroucelImg={carroucelImg1} arrows="black"/>
                </div>
                <div style={{ padding: "15px", fontSize: "large", textAlign: "justify", ...generalStyleDivs }}>
                    <span style={{ padding: "10px" }} dangerouslySetInnerHTML={{ __html: pageText }} />
                    <span style={{ padding: "10px" }} dangerouslySetInnerHTML={{ __html: pageText2 }} />
                    <span style={{ padding: "10px" }} dangerouslySetInnerHTML={{ __html: pageText3 }} />
                </div>
            </div>
          }
          <Footer/>
        </>
    )
}

export default SpecialtyCoffeePage;